import React from "react";
import { Box, Typography } from "@mui/material";
import './SIKIload.scss'; // Import the CSS file

const SIKIload = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "black", // Dark background
      }}
    >
      {/* SIKI Text */}
      <Typography
        sx={{
          fontFamily: "Impact, sans-serif",
          fontSize: "64px", // Adjust size as needed
          color: "#FFEE20",
          letterSpacing: "8px",
        }}
      >
        SIKI
      </Typography>

      {/* Wave Columns */}
      <Box
        sx={{
          display: "flex",
          gap: "15px",
          marginTop: "30px",
        }}
      >
        {/* Create 5 columns with animation */}
        {[...Array(5)].map((_, index) => (
          <Box
            key={index}
            sx={{
              width: "15px",
              height: "60px",
              backgroundColor: "#FFEE20",
              borderRadius: "5px",
              animation: `wave 1.5s ${index * 0.15}s infinite ease-in-out`,
            }}
          />
        ))}
      </Box>

      {/* Keyframes for the wave animation */}
      <style jsx="true">{`
        @keyframes wave {
          0%,
          100% {
            transform: scaleY(1);
          }
          50% {
            transform: scaleY(0.5);
          }
        }
      `}</style>
    </Box>
  );
};

export default SIKIload;
